<template>
  <div>
    <section-header size="xl" variants="dividing" class="mt-3">
      <heading :level="1" size="xl" qaid="warranty-claim-header" v-html="claimHeader" />
    </section-header>

    <!-- Contact Info -->
    <section class="my-6">
      <section-header size="md" variants="dividing" class="mb-3">
        <heading :level="3" size="md" qaid="warranty-claim-contact-info" v-html="getBaseProperty('claimContactInfo')" />
      </section-header>

      <dl class="description-list grid-x grid-margin-x max-w-sm">
        <dt class="cell small-5" qaid="warranty-claim-person-label" v-html="getBaseProperty('contactPerson')" />
        <dd class="cell small-7" qaid="warranty-claim-person" v-html="claimData.contactName" />
        <dt class="cell small-5" qaid="warranty-claim-phone-label" v-html="getBaseProperty('phone')" />
        <dd class="cell small-7" qaid="warranty-claim-phone" v-html="claimData.contactPhoneNumber" />
        <dt class="cell small-5" qaid="warranty-claim-email-label" v-html="getBaseProperty('email')" />
        <dd class="cell small-7" qaid="warranty-claim-email" v-html="claimData.contactEmail" />
      </dl>
    </section>

    <!-- Claim Details -->
    <section class="my-6">
      <section-header size="md" variants="dividing" class="mb-3">
        <heading :level="3" size="md" qaid="warranty-claim-details" v-html="getBaseProperty('claimDetails')" />
      </section-header>

      <dl class="description-list grid-x grid-margin-x max-w-sm">
        <dt class="cell small-5" qaid="warranty-claim-number-label" v-html="getBaseProperty('claimNumberView')" />
        <dd class="cell small-7" qaid="warranty-claim-number" v-html="claimData.id" />
        <dt class="cell small-5" qaid="warranty-claim-date-label" v-html="getBaseProperty('dateSubmitted')" />
        <dd class="cell small-7" qaid="warranty-claim-date" v-html="claimData.lastSavedDate" />
        <dt class="cell small-5" qaid="warranty-claim-po-label" v-html="getBaseProperty('claimPO')" />
        <dd class="cell small-7" qaid="warranty-claim-po" v-html="claimData.poNumber" />
        <dt class="cell small-5" qaid="warranty-claim-notes-label" v-html="getBaseProperty('claimNotes')" />
        <dd class="cell small-7" qaid="warranty-claim-notes" v-html="claimData.notes" />
        <dt class="cell small-5" qaid="warranty-claim-service-label" v-html="getBaseProperty('serviceCenterRepair')" />
        <dd class="cell small-7" qaid="warranty-claim-service" v-html="claimData.nonWarClaimFlagValue" />
      </dl>
    </section>

    <!-- Claim Lines -->
    <section class="my-6">
      <section-header size="lg" variants="dividing">
        <heading :level="2" size="lg" qaid="warranty-claim-lines" v-html="getBaseProperty('claimLines')" />
      </section-header>

      <collapse
        icon-active="indeterminate_check_box"
        icon-inactive="add_box"
        icon-position="right"
        :default-active="false"
        :value="expandedClaims"
        @change="claimLineExpansionChange"
      >
        <collapse-item
          v-for="(claimLine, claimIndex) in claimData.claimLines"
          :key="claimIndex"
          :title="getBaseProperty('claimLineNumber', claimIndex + 1)"
          :name="`line${claimIndex}`"
        >
          <div
            slot="title"
            class="heading heading--md"
            qaid="warranty-claim-line-title"
            v-html="getBaseProperty('claimLineNumber', claimIndex + 1)"
          />

          <warranty-claim-view-Line
            :base-properties="baseProperties"
            :claim-line="claimLine"
            :claim-data="claimData"
            :claim-index="claimIndex"
          />
        </collapse-item>
      </collapse>
    </section>
  </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader';
import Collapse from '@/components/Collapse';
import CollapseItem from '@/components/CollapseItem';
import WarrantyClaimViewLine from '@/components/containers/warranty-claim/WarrantyClaimViewLine';
import Heading from '@/components/Heading';

export default {
  components: {Collapse, CollapseItem, SectionHeader, Heading, WarrantyClaimViewLine},
  props: {
    baseProperties: {
      type: Array,
      required: true,
    },
    claimData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      expandedClaims: ['line0'],
    };
  },

  computed: {
    claimHeader() {
      return this.getBaseProperty('claimNumber', this.claimData.id);
    },
  },

  methods: {
    claimLineExpansionChange(payload) {
      this.expandedClaims = payload;
    },
  },
};
</script>
